/// <amd-module name="Pipeline/Analytics/PipelineOutcome/PipelineOutcomeHub/Actions/PipelineOutcomeHubActionsCreator" />
import { IReportContext } from "Analytics/Shared/Common/Types";
import { ITrendChartAggregateData, ITrendChartReportConfiguration } from "Analytics/Shared/TrendChart/Common/Types";
import { IPipelineAnalyticsTelemetryService } from "Pipeline/Analytics/Common/Telemetry/PipelineAnalyticsTelemetryService";
import * as TelemetryConstants from "Pipeline/Analytics/Common/Telemetry/TelemetryConstants";
import { PipelineOutcomeFailureTrendActions } from "Pipeline/Analytics/PipelineOutcome/FailureTrendCard/Actions/PipelineOutcomeFailureTrendActions";
import { PipelineOutcomePassRateTrendActions } from "Pipeline/Analytics/PipelineOutcome/PassRateTrendCard/Actions/PipelineOutcomePassRateTrendActions";
import { PipelineOutcomeHubSource } from "Pipeline/Analytics/PipelineOutcome/PipelineOutcomeHub/Sources/PipelineOutcomeHubSource";
import { IVssPageContext } from "VSS/Platform/Context";

export class PipelineOutcomeHubActionsCreator {
    private _pipelineOutcomeHubSource: PipelineOutcomeHubSource;

    constructor(
        private _pipelineOutcomePassRateTrendActions: PipelineOutcomePassRateTrendActions,
        private _pipelineOutcomeFailureTrendActions: PipelineOutcomeFailureTrendActions,
        private _pageContext: IVssPageContext
    ) {
        this._pipelineOutcomeHubSource = new PipelineOutcomeHubSource(_pageContext);
    }

    public updateConfigurationValues(reportContext: IReportContext, newConfValues: ITrendChartReportConfiguration): Promise<void> {
        this._pipelineOutcomePassRateTrendActions.updateConfigurationValuesAction.invoke(newConfValues);
        this._pipelineOutcomeFailureTrendActions.updateConfigurationValuesAction.invoke(newConfValues);
        return this._updateTrendChart(reportContext, newConfValues);
    }

    private async _updateTrendChart(reportContext: IReportContext, confValues: ITrendChartReportConfiguration): Promise<void> {
        try {
            const pipelineOutcomeData = await this._pipelineOutcomeHubSource.queryPipelineTrendData(reportContext, confValues);
            this._publishPassPercentageTrendTelemetry(pipelineOutcomeData.trendChartData.secondaryChartData!);
            this._pipelineOutcomePassRateTrendActions.updateDataAction.invoke(pipelineOutcomeData);
            this._pipelineOutcomeFailureTrendActions.updateDataAction.invoke(pipelineOutcomeData);
        } catch (error) {
            this._pipelineOutcomePassRateTrendActions.onError.invoke(error);
            this._pipelineOutcomeFailureTrendActions.onError.invoke(error);
            return Promise.reject(error);
        }
    }

    private _publishPassPercentageTrendTelemetry(passPercentageTrend: ITrendChartAggregateData[]): void {
        const telemetryService = this._pageContext.getService<IPipelineAnalyticsTelemetryService>("IPipelineAnalyticsTelemetryService");
        telemetryService.publishEventWithSingleKey(
            TelemetryConstants.feature_PipelineAnalyticsOutcomeTrendChart,
            TelemetryConstants.OutcomeTrendChartData,
            passPercentageTrend
        );
    }
}
